import { DiModuleBuilder } from "@di/builder/di-module-builder";
import { ContainerModule } from "inversify";
import { CatalogueDatasource } from "./data/datasource/catalogue.datasource";
import { CreateServiceMapper } from "./data/mappers/service/create-service.mapper";
import { ServiceMapper } from "./data/mappers/service/service.mapper";
import { CatalogueRepository } from "./data/repositories/catalogue.repository";
import { CreateServiceUseCase } from "./domain/usecases/create-service.usecase";
import { GetAllServicesUseCase } from "./domain/usecases/get-all-services.usecase";
import { CreateServicePageViewModel } from "./presentation/pages/service/create/create-service-page.viewmodel";
import { ServiceListPageViewModel } from "./presentation/pages/service/service-list-page.viewmodel";
import { DerivationMapper } from "./data/mappers/derivation/derivation.mapper";
import { CreateDerivationMapper } from "./data/mappers/derivation/create-derivation.mapper";
import { GetAllDerivationsUseCase } from "./domain/usecases/get-all-derivations.usecase";
import { CreateDerivationUseCase } from "./domain/usecases/create-derivation.usecase";
import { DerivationListPageViewModel } from "./presentation/pages/derivation/derivation-list-page.viewmodel";
import { GetServiceByIdUseCase } from "./domain/usecases/get-service-by-id.usecase";
import { DeleteServiceUseCase } from "./domain/usecases/delete-service.usecase";
import { DocumentsTabViewModel } from "./presentation/components/derivation/documents/document-tab.viewmodel";
import { UpdateDerivationMapper } from "./data/mappers/derivation/edit-derivation.mapper";
import { UpdateDerivationUseCase } from "./domain/usecases/update-derivation.usecase";
import { GetDerivationByIdUseCase } from "./domain/usecases/get-derivation-by-id.usecase";
import { DerivationEditPageViewModel } from "./presentation/pages/derivation/edit/derivation-edit-page.viewmodel";
import { DerivationCreatePageViewModel } from "./presentation/pages/derivation/create/derivation-create-page.viewmodel";


const catalogueModule = new DiModuleBuilder();

catalogueModule.registerSubModules(() => ({
    datasources: new ContainerModule((bind) => {
        bind(CatalogueDatasource).toSelf();
    }),
    mappers: new ContainerModule((bind) => {
        bind(ServiceMapper).toSelf();
        bind(CreateServiceMapper).toSelf();
        bind(DerivationMapper).toSelf();
        bind(CreateDerivationMapper).toSelf();
        bind(UpdateDerivationMapper).toSelf();
    }),
    repositories: new ContainerModule((bind) => {
        bind(CatalogueRepository).toSelf();
    }),
    useCases: new ContainerModule((bind) => {
        bind(GetAllServicesUseCase).toSelf();
        bind(CreateServiceUseCase).toSelf();
        bind(GetAllDerivationsUseCase).toSelf();
        bind(CreateDerivationUseCase).toSelf();
        bind(GetServiceByIdUseCase).toSelf();
        bind(DeleteServiceUseCase).toSelf();
        bind(GetDerivationByIdUseCase).toSelf();
        bind(UpdateDerivationUseCase).toSelf();
    }),
    viewModels: new ContainerModule((bind) => {
        bind(ServiceListPageViewModel).toSelf();
        bind(CreateServicePageViewModel).toSelf();
        bind(DerivationListPageViewModel).toSelf();
        bind(DocumentsTabViewModel).toSelf().inSingletonScope();
        bind(DerivationEditPageViewModel).toSelf();
        bind(DerivationCreatePageViewModel).toSelf();
    }),
}));

catalogueModule.registerModule();

export { catalogueModule };
